import moment from 'moment';
import 'moment/locale/id';
import React, { Component, lazy, Suspense } from 'react';
import { Responsive, WidthProvider } from "react-grid-layout";

/* Sagas Action */
import { buildWSelector } from '../../../../redux/ducks'

import { safeDeepGet, safeDeepGetWithType, parse, clean, isJsonEqual } from 'iotera-base/json';
import { isEmpty, isNumber, isObject, isFunction, isNone } from 'iotera-base/object';
import { isFloat } from '../../../../lib/function'
import {
  ButtonInputCardDate,
  ButtonInputCardDateRange,
  ButtonInputCardNumber,
  ButtonInputCardText,
  ButtonInputCardToggle,
  SimpleButtonCard
} from '../../card/button/simple_button_card_grid';
import * as preference from '../../Preference';
import './style.scss';
import { toDate, inputToString, titleCase, toDashboardDate, removeBracet } from '../../formatter';
import { SuspenseLoading } from '../../react/react-loader';
import { Button } from '@material-ui/core';
import { ioteraConfirmAlert } from '../../react/react-confirm-alert';
import IoteraClass from '../../react/react-class';
import { UploadCSVCard } from '../../card/button/upload/csv';
import Result from 'iotera-base/result';
import { setObjectData, setOrderDataCard } from '../../function'
import '../../../../lib/style.css'

const TitleGrid = lazy(() => import('../../separator').then(module => ({ default: module.TitleGrid })));
const DropdownSelectorGrid = lazy(() => import('../../selector/dropdown_selector').then(module => ({ default: module.DropdownSelectorGrid })));
const CustomCardGrid = lazy(() => import('../../card/custom_card').then(module => ({ default: module.CustomCardGrid })));
const SingleImageCard = lazy(() => import('../../card/single_image_card').then(module => ({ default: module.SingleImageCard })));
const DataValueCardGrid = lazy(() => import('../../card/data_value_card').then(module => ({ default: module.DataValueCardGrid })));
const AmpereCardGrid = lazy(() => import('../../card/electricity/ampere_card').then(module => ({ default: module.AmpereCardGrid })));
const KWHCardGrid = lazy(() => import('../../card/electricity/kwh_card').then(module => ({ default: module.KWHCardGrid })));
const KWCardGrid = lazy(() => import('../../card/electricity/kw_card').then(module => ({ default: module.KWCardGrid })));
const OhmCardGrid = lazy(() => import('../../card/electricity/ohm_card').then(module => ({ default: module.OhmCardGrid })));
const VoltCardGrid = lazy(() => import('../../card/electricity/volt_card').then(module => ({ default: module.VoltCardGrid })));
const WattCardGrid = lazy(() => import('../../card/electricity/watt_card').then(module => ({ default: module.WattCardGrid })));
const GraphCard = lazy(() => import('../../card/graph_card').then(module => ({ default: module.GraphCard })));
const HumidityCardGrid = lazy(() => import('../../card/humidity_card').then(module => ({ default: module.HumidityCardGrid })));
const ListCard = lazy(() => import('../../card/list_card').then(module => ({ default: module.ListCard })));
const PercentageCardGrid = lazy(() => import('../../card/percent/percentage_card').then(module => ({ default: module.PercentageCardGrid })));
const PreasureAirCardGrid = lazy(() => import('../../card/preasure/preasure_air_card').then(module => ({ default: module.PreasureAirCardGrid })));
const PreasureWaterCardGrid = lazy(() => import('../../card/preasure/preasure_water_card').then(module => ({ default: module.PreasureWaterCardGrid })));
const SalesCardGrid = lazy(() => import('../../card/sales_card').then(module => ({ default: module.SalesCardGrid })));
const CelciusCardGrid = lazy(() => import('../../card/temperature/celcius_card').then(module => ({ default: module.CelciusCardGrid })));
const FahrenheitCardGrid = lazy(() => import('../../card/temperature/fahrenheit_card').then(module => ({ default: module.FahrenheitCardGrid })));
const KelvinCardGrid = lazy(() => import('../../card/temperature/kelvin_card').then(module => ({ default: module.KelvinCardGrid })));
const ThreePhaseCard = lazy(() => import('../../card/three_phase_card').then(module => ({ default: module.ThreePhaseCard })));
const VersionCardGrid = lazy(() => import('../../card/version_card').then(module => ({ default: module.VersionCardGrid })));
const ControlButtonCard = lazy(() => import('../../card/button/control').then(module => ({ default: module.ControlButtonCard })));
const ControlButtonCardBoolean = lazy(() => import('../../card/button/control').then(module => ({ default: module.ControlButtonCardBoolean })));
const ControlButtonCardNumber = lazy(() => import('../../card/button/control').then(module => ({ default: module.ControlButtonCardNumber })));
const ControlButtonCardString = lazy(() => import('../../card/button/control').then(module => ({ default: module.ControlButtonCardString })));
const CustomControlButtonCard = lazy(() => import('../../card/button/control_custom').then(module => ({ default: module.CustomControlButtonCard })));
const CustomControlButtonCardNumber = lazy(() => import('../../card/button/control_custom').then(module => ({ default: module.CustomControlButtonCardNumber })));
const CustomControlButtonCardBoolean = lazy(() => import('../../card/button/control_custom').then(module => ({ default: module.CustomControlButtonCardBoolean })));
const GoogleMapCard = lazy(() => import('../../card/map/google_map').then(module => ({ default: module.GoogleMapCard })));
const CoordinateCard = lazy(() => import('../../card/coordinate_card').then(module => ({ default: module.CoordinateCard })));
const StrainCard = lazy(() => import('../../card/strain_card').then(module => ({ default: module.StrainCard })))
const CrackCard = lazy(() => import('../../card/crack_card').then(module => ({ default: module.CrackCard })))
const SimpleDownloadCard = lazy(() => import('../../card/button/download').then(module => ({ default: module.SimpleDownloadCard })));

const originalLayouts = getFromLS("layouts") || {};

const ResponsiveGridLayout = WidthProvider(Responsive);

// TODO for gap between card
const MARGIN = 36

const ROW_HEIGHT = 60

// selector redux
let wSelector = null

// Fit Height
function calcGridHeight(basedHeight) {
  return ((basedHeight * ROW_HEIGHT) + ((basedHeight - 1) * MARGIN) - 2)
}

// class for dashboard preview and dashboard config
export class DynamicGridGenerator extends Component {
  constructor(props) {
    super(props);
    let navId = safeDeepGetWithType(props, ['navId'], '')
    let layouts = getFromLS(navId);
    this.state = {
      layouts
    };
    this.resize = this.resize.bind(this);
    this.onLayoutChange = this.onLayoutChange.bind(this);
    this.onResize = this.onResize.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    const wsKey = safeDeepGet(this.props, ['wsKey'])
    if (isNone(wsKey)) {
      return
    }
    wSelector = buildWSelector(wsKey);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const _this = this
    let currProps = _this.props
    let currState = _this.state
    let dataCurrProps = safeDeepGet(currProps, ['data'])
    let dataNextProps = safeDeepGet(nextProps, ['data'])
    let onDragCurrState = safeDeepGet(currState, ['onDrag'])
    let onDragNextState = safeDeepGet(nextState, ['onDrag'])
    let sameProps = isJsonEqual(dataCurrProps, dataNextProps);
    let sameState = isJsonEqual(onDragCurrState, onDragNextState);
    return !sameProps || !sameState;
  }

  resize(event) {
  }

  handleEdit(id) {
    let _handleEdit = safeDeepGet(this, ['props', 'handleEdit']);
    if (isFunction(_handleEdit)) {
      ioteraConfirmAlert(
        'Konfirmasi',
        'Ingin edit manual atau dengan bantuan editor?',
        'Editor',
        () => _handleEdit(id, true),
        'Manual',
        () => _handleEdit(id, false),
      )
    }
  }

  handleDelete(id) {
    let _handleDelete = safeDeepGet(this, ['props', 'handleDelete']);
    if (isFunction(_handleDelete)) {
      ioteraConfirmAlert(
        'Konfirmasi',
        'Apakah anda yakin ingin menghapus dashboard component ini?',
        null,
        () => _handleDelete(id),
        null,
        null
      )
    }
  }

  onLayoutChange = (layout, layouts) => {
    const _this = this
    const _props = _this.props
    let handleChangeLayout = safeDeepGetWithType(_props, ['handleChangeLayout']);
    if (isFunction(handleChangeLayout)) {
      handleChangeLayout(layouts);
    }
    _this.setState({ layouts });
  };

  onResize(layout, oldLayoutItem, layoutItem, placeholder) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let breakpoint = 'xxs';
    let width = window.innerWidth
    if (width >= 1200) {
      breakpoint = 'lg'
    } else if (width >= 996) {
      breakpoint = 'md'
    } else if (width >= 768) {
      breakpoint = 'sm'
    } else if (width >= 480) {
      breakpoint = 'xs'
    }
    if (breakpoint === 'md' || breakpoint === 'lg') {
      let layouts = safeDeepGetWithType(_state, ['layouts'], {})
      let handleChangeLayout = safeDeepGetWithType(_props, ['handleChangeLayout']);
      layouts[breakpoint] = layout;
      if (isFunction(handleChangeLayout)) {
        handleChangeLayout(layouts);
      }
      _this.setState({ layouts });
    }
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    window.onresize = _this.resize;
    let layouts = safeDeepGetWithType(_state, ['layouts'], {});
    let onDrag = safeDeepGetWithType(_state, ['onDrag'], false);
    let config = safeDeepGetWithType(_props, ['config'], {});
    let data = safeDeepGetWithType(_props, ['data'], {});
    let contentWidth = safeDeepGetWithType(_props, ['contentWidth'], 360);
    let _refresh_rate = safeDeepGetWithType(_props, ['_refresh_rate'], 0);
    let staticGrid = safeDeepGetWithType(_props, ['staticGrid'], false);

    // handle
    let handleControl = safeDeepGet(_props, ['handleControl']);
    let handleDropdown = safeDeepGet(_props, ['handleDropdown']);
    let handleControlCustom = safeDeepGet(_props, ['handleControlCustom']);
    let handleDropdownCustom = safeDeepGet(_props, ['handleDropdownCustom']);
    let handlePeriod = safeDeepGet(_props, ['handlePeriod']);
    let handlePeriodDate = safeDeepGet(_props, ['handlePeriodDate']);
    let handleDownload = safeDeepGet(_props, ['handleDownload']);
    let handleClick = safeDeepGet(_props, ['handleClick']);
    let handleSelector = safeDeepGet(_props, ['handleSelector']);
    let handleSelectFirstItem = safeDeepGet(_props, ['handleSelectFirstItem']);
    let handleUploadCsv = safeDeepGet(_props, ['handleUploadCsv']);

    let isDraggable = staticGrid ? false : true;

    let breakpoint = 'xxs';
    let width = window.innerWidth
    if (width >= 1200) {
      breakpoint = 'lg'
    } else if (width >= 996) {
      breakpoint = 'md'
    } else if (width >= 768) {
      breakpoint = 'sm'
    } else if (width >= 480) {
      breakpoint = 'xs'
    }

    if (breakpoint === 'sm' || breakpoint === 'xs' || breakpoint === 'xxs') {
      isDraggable = false;
    }
    let mainViewDashConfig = []
    let mainViewDashPreview = []

    // data for dashboard preview (array)
    let dataCard = []
    let _full_number = safeDeepGetWithType(_props, ['dash_view', 'full_number'], false);
    let _decimal = safeDeepGetWithType(_props, ['dash_view', 'decimal'], 2);
    let _from_zero = safeDeepGetWithType(_props, ['dash_view', 'graph_from_zero'], false);
    let _colors = safeDeepGetWithType(_props, ['dash_view', 'graph_colors'], preference.COLOR_PALETTE);

    let _yaxis_min = safeDeepGet(_props, ['dash_view', 'graph_yaxis_min'], 'auto');
    let _yaxis_max = safeDeepGet(_props, ['dash_view', 'graph_yaxis_max'], 'auto');

    for (let key in config) {
      let cardView = null;
      let mainConfig = safeDeepGetWithType(config, [key], {});
      let refresh_rate = safeDeepGetWithType(mainConfig, ['config', 'refresh'], _refresh_rate);
      let mainData = wSelector.getRPayloadFromMappedState(data, key)
      const response_result = safeDeepGetWithType(data, [key, 'result', 'body', 'response_result'], Result.UNKNOWN_ERROR);
      let cat = safeDeepGetWithType(mainConfig, ['cat'], "CARD");
      // Basic config
      let id = key;
      let x = safeDeepGetWithType(mainConfig, ['x'], 0);
      let minW = 1;
      let minH = 2;
      let maxW = 4;
      let maxH = 6;
      let y = safeDeepGetWithType(mainConfig, ['y'], 0);
      y *= 2
      let w = safeDeepGetWithType(mainConfig, ['w'], 0);
      let h = safeDeepGetWithType(mainConfig, ['h'], 0);
      h *= 2
      let size = safeDeepGetWithType(mainConfig, ['w'], 0);
      if (size === 0) {
        size = 1;
      }

      // View Config
      let title = safeDeepGetWithType(mainConfig, ['view', 'title'], '');
      title = titleCase(title);
      let type = safeDeepGetWithType(mainConfig, ['view', 'type'], "CUSTOM");
      let unit = safeDeepGetWithType(mainConfig, ['view', 'unit'], '');
      let unit_front = safeDeepGetWithType(mainConfig, ['view', 'unit_front'], false);
      let pict = safeDeepGetWithType(mainConfig, ['view', 'pict'], '');

      // Chart Config
      let xlabel = safeDeepGetWithType(mainConfig, ['view', 'xlabel'], '');
      let ylabel = safeDeepGetWithType(mainConfig, ['view', 'ylabel'], '');
      let is_stack = safeDeepGetWithType(mainConfig, ['view', 'is_stack'], false);
      let has_dot = safeDeepGetWithType(mainConfig, ['view', 'has_dot'], true);
      let graph_unit = safeDeepGetWithType(mainConfig, ['view', 'graph_unit'], '');
      let graph_colors = safeDeepGetWithType(mainConfig, ['view', 'graph_colors'], _colors);
      let graph_from_zero = safeDeepGetWithType(mainConfig, ['view', 'graph_from_zero'], _from_zero);
      let graph_yaxis_min = safeDeepGet(mainConfig, ['view', 'graph_yaxis_min'], _yaxis_min);
      let graph_yaxis_max = safeDeepGet(mainConfig, ['view', 'graph_yaxis_max'], _yaxis_max);
      let graph_reference_line_value = safeDeepGet(mainConfig, ['view', 'graph_reference_line_value']);
      let graph_reference_line_label = safeDeepGet(mainConfig, ['view', 'graph_reference_line_label']);

      if (!isNumber(graph_yaxis_min) && !isFloat(graph_yaxis_min)) {
        graph_yaxis_min = 'auto'
      }

      if (!isNumber(graph_yaxis_max) && !isFloat(graph_yaxis_max)) {
        graph_yaxis_max = 'auto'
      }

      let graph_unit_front = safeDeepGetWithType(mainConfig, ['view', 'graph_unit_front'], false);
      let with_summary = safeDeepGetWithType(mainConfig, ['view', 'with_summary'], is_stack);
      let is_dashed = safeDeepGetWithType(mainConfig, ['view', 'is_dashed'], false);

      // Devices Control Config
      let devices = safeDeepGetWithType(mainConfig, ['view', 'devices'], []);

      // Input Config
      let button_label = safeDeepGetWithType(mainConfig, ['view', 'button_label'], '');

      // Decimal to show
      let decimalToShow = safeDeepGetWithType(mainConfig, ['view', 'decimal'], _decimal);

      // limit decimalToShow
      decimalToShow = decimalToShow > 5 ? 5 : decimalToShow;

      let fullNumber = safeDeepGetWithType(mainConfig, ['view', 'full_number'], _full_number);
      let isSimpleNumber = !fullNumber;

      // Input Number Config
      let min = safeDeepGetWithType(mainConfig, ['view', 'min'], 0);
      let max = safeDeepGetWithType(mainConfig, ['view', 'max'], 1000000);

      // Input Datetime Config
      let locale = safeDeepGetWithType(mainConfig, ['view', 'locale'], "id-ID");
      let date_format = safeDeepGet(mainConfig, ['view', 'date_format'], true);
      let time_format = safeDeepGet(mainConfig, ['view', 'time_format'], false);

      // Single Value Data
      let value = safeDeepGet(mainData, ['value'], '-');
      value = inputToString(value);
      let time = safeDeepGetWithType(mainData, ['time'], "-");
      let timeFull = "-";
      if (time !== "-") {
        timeFull = toDate(time)
        time = toDashboardDate(time);
      }

      let status = safeDeepGetWithType(mainData, ['status'], '');
      let success = safeDeepGetWithType(mainData, ['success'], true);

      // Three Phase Value Data
      let value_1 = safeDeepGet(mainData, ['value_1'], '-');
      let value_2 = safeDeepGet(mainData, ['value_2'], '-');
      let value_3 = safeDeepGet(mainData, ['value_3'], '-');
      value_1 = inputToString(value_1);
      value_2 = inputToString(value_2);
      value_3 = inputToString(value_3);
      let status_1 = safeDeepGetWithType(mainData, ['status_1'], '');
      let status_2 = safeDeepGetWithType(mainData, ['status_2'], '');
      let status_3 = safeDeepGetWithType(mainData, ['status_3'], '');

      // coordinate data and config
      const ticksX = [-15, -10, -5, 0, 5, 10, 15]
      const ticksY = [-15, -10, -5, 0, 5, 10, 15]

      let axis_x = safeDeepGet(mainConfig, ['view', 'axis_x'], ticksX)
      let axis_y = safeDeepGet(mainConfig, ['view', 'axis_y'], ticksY)
      let unit_x = safeDeepGet(mainConfig, ['view', 'unit_x'], 'mm')
      let unit_y = safeDeepGet(mainConfig, ['view', 'unit_y'], 'mm')
      let color_dot = safeDeepGet(mainConfig, ['view', 'color_dot'], '#7E57C2')
      let coord_data = safeDeepGet(mainData, ['coord_data', 0], { 'x': 0, 'y': 0 })

      // crack data and config 
      let value_crack = safeDeepGet(mainData, 'value', 0)
      let label_init_crack = safeDeepGet(mainConfig, ['view', 'label_init_crack'], '')
      let label_value_crack = safeDeepGet(mainConfig, ['view', 'label_value_crack'], '')
      let init_length_crack = safeDeepGet(mainConfig, ['view', 'init_length_crack'], 0)
      let max_length_crack = safeDeepGet(mainConfig, ['view', 'max_length_crack'], 0)
      let min_length_crack = safeDeepGet(mainConfig, ['view', 'min_length_crack'], 0)
      let color_init_crack = safeDeepGet(mainConfig, ['view', 'color_init_crack'], '#4D2C91')
      let color_plus_crack = safeDeepGet(mainConfig, ['view', 'color_plus_crack'], 'green')
      let color_minus_crack = safeDeepGet(mainConfig, ['view', 'color_minus_crack', 'red'])
      let unit_crack = safeDeepGet(mainConfig, ['view', 'unit_crack'], '')

      // strain data and config
      let value_strain = safeDeepGet(mainData, 'value', 0)
      let label_init_strain = safeDeepGet(mainConfig, ['view', 'label_init_strain'], '')
      let label_value_strain = safeDeepGet(mainConfig, ['view', 'label_value_strain'], '')
      let init_curve_strain = safeDeepGet(mainConfig, ['view', 'init_curve_strain'], 0)
      let min_curve_strain = safeDeepGet(mainConfig, ['view', 'min_curve_strain'], 0)
      let max_curve_strain = safeDeepGet(mainConfig, ['view', 'max_curve_strain'], 0)
      let color_init_strain = safeDeepGet(mainConfig, ['view', 'color_init_strain'], '#4D2C91')
      let color_plus_strain = safeDeepGet(mainConfig, ['view', 'color_plus_strain'], 'green')
      let color_minus_strain = safeDeepGet(mainConfig, ['view', 'color_minus_strain'], 'red')
      let unit_strain = safeDeepGet(mainConfig, ['view', 'unit_strain'], '')

      // text chart data and config
      let type_line = safeDeepGet(mainConfig, ['view', 'type_line'], '')
      let color_line = safeDeepGet(mainConfig, ['view', 'color_line'], '#8884d8')

      // Input Data
      let default_value = safeDeepGet(mainData, ['value'], '');
      default_value = inputToString(default_value);
      let default_value_int = safeDeepGet(mainData, ['value'], 0);
      let default_value_bool = safeDeepGet(mainData, ['value'], false);

      // Chart Data
      let chart = safeDeepGetWithType(mainData, ['chart_data'], []);
      let chart_keys = safeDeepGetWithType(mainData, ['chart_keys'], []);
      let is_second_shown = safeDeepGetWithType(mainData, ['is_second_shown'], false);
      let chart_period = safeDeepGetWithType(mainConfig, ['model', 'filter'], {});

      // Map Data
      let marker = safeDeepGetWithType(mainData, ['map_marker', 'data'], []);
      let devicesTemp = safeDeepGetWithType(mainData, ['devices'], []);
      if (devicesTemp.length > 0) {
        devices = devicesTemp
      }

      let dashboard_affects = safeDeepGetWithType(mainData, ['affect'], []);
      let map_type = safeDeepGetWithType(mainConfig, ['model', 'map_type'], 'roadmap');

      // Table Data
      let table = safeDeepGetWithType(mainData, ['table_data'], []);
      let table_keys = safeDeepGetWithType(mainData, ['table_keys'], []);

      // Loading
      let is_loading = safeDeepGetWithType(mainData, ['is_loading'], false);

      let imageUrl = safeDeepGetWithType(mainConfig, ['model', 'image_url'], '');
      let alert = safeDeepGet(mainData, ['alert'], {});
      let primary = safeDeepGet(mainData, ['primary'], {});
      let secondary = safeDeepGet(mainData, ['secondary'], {});
      let enable = safeDeepGet(mainData, ['enable'], false);
      let dataToShare = {
        "key": id,
        id,
        refresh_rate,
        cat,
        x,
        y,
        w,
        h,
        size,

        title,
        type,
        unit,
        unit_front,
        pict,

        xlabel,
        ylabel,
        is_stack,
        has_dot,
        graph_unit,
        graph_unit_front,
        graph_from_zero,
        graph_yaxis_min,
        graph_yaxis_max,
        graph_reference_line_value,
        graph_reference_line_label,
        graph_colors,
        with_summary,
        is_dashed,
        contentWidth,

        button_label,

        devices,

        min,
        max,

        locale,
        date_format,
        time_format,

        value,

        value_1,
        value_2,
        value_3,
        // TODO
        date: timeFull,
        date_short: time,
        status,

        axis_x,
        axis_y,
        unit_x,
        unit_y,
        color_dot,
        coord_data,

        value_crack,
        label_init_crack,
        label_value_crack,
        init_length_crack,
        max_length_crack,
        min_length_crack,
        color_init_crack,
        color_plus_crack,
        color_minus_crack,
        unit_crack,

        value_strain,
        label_init_strain,
        label_value_strain,
        init_curve_strain,
        min_curve_strain,
        max_curve_strain,
        color_init_strain,
        color_plus_strain,
        color_minus_strain,
        unit_strain,

        status_1,
        status_2,
        status_3,

        success,

        default_value,
        default_value_int,
        default_value_bool,

        data: chart,
        chart_keys,
        is_second_shown,
        chart_period,

        type_line,
        color_line,

        marker,
        dashboard_affects,
        map_type,
        decimalToShow,
        isSimpleNumber,

        table,
        table_keys,

        is_loading,

        on_click: handleClick,
        handleDropdown,
        handleControl,
        handleDropdownCustom,
        handleControlCustom,
        handlePeriod,
        handlePeriodDate,
        handleDownload,
        handleSelector,
        handleSelectFirstItem,
        handleUploadCsv,

        imageUrl,
        alert,
        primary,
        secondary,

        response_result,
        enable
      }

      clean(dataToShare);
      let cardHeight = calcGridHeight(h);
      dataToShare.cardHeight = cardHeight;
      let skeletonWidth = '100%'
      let skeletonPosition = 'left'

      let hasFocus = false;

      // data for dashboard preview (object)
      let dataCardObject

      if (cat === preference.TYPE_CARD_VALUE) {
        h = 2;
        hasFocus = true;
        minW = 1;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataToShare.cardHeight = calcGridHeight(h);
        switch (type) {
          case preference.TYPE_CUSTOM:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <CustomCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <CustomCardGrid {...dataToShare} />
            break;
          case preference.TYPE_AMPERE:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <AmpereCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <AmpereCardGrid {...dataToShare} />
            break;
          case preference.TYPE_KW:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <KWCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <KWCardGrid {...dataToShare} />
            break;
          case preference.TYPE_KWH:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <KWHCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <KWHCardGrid {...dataToShare} />
            break;
          case preference.TYPE_OHM:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <OhmCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <OhmCardGrid {...dataToShare} />
            break;
          case preference.TYPE_VOLT:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <VoltCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <VoltCardGrid {...dataToShare} />
            break;
          case preference.TYPE_WATT:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <WattCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <WattCardGrid {...dataToShare} />
            break;
          case preference.TYPE_HUMIDITY:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <HumidityCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <HumidityCardGrid {...dataToShare} />
            break;
          case preference.TYPE_PERCENT:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <PercentageCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <PercentageCardGrid {...dataToShare} />
            break;
          case preference.TYPE_PRESSURE_AIR:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <PreasureAirCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <PreasureAirCardGrid {...dataToShare} />
            break;
          case preference.TYPE_PRESSURE_WATER:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <PreasureWaterCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <PreasureWaterCardGrid {...dataToShare} />
            break;
          case preference.TYPE_RUPIAH:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <SalesCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <SalesCardGrid {...dataToShare} />
            break;
          case preference.TYPE_TEMPERATURE_CELCIUS:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <CelciusCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <CelciusCardGrid {...dataToShare} />
            break;
          case preference.TYPE_TEMPERATURE_FAHRENHEIT:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <FahrenheitCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <FahrenheitCardGrid {...dataToShare} />
            break;
          case preference.TYPE_TEMPERATURE_KELVIN:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <KelvinCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <KelvinCardGrid {...dataToShare} />
            break;
          case preference.TYPE_VERSION:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <VersionCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <VersionCardGrid {...dataToShare} />
            break;
          default:
            dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
              <CustomCardGrid {...dataToShare} />, dataToShare)
            dataCard.push(dataCardObject)
            cardView =
              <CustomCardGrid {...dataToShare} />
            break;
        }
      } else if (cat === preference.SINGLE_IMAGE_CARD) {
        hasFocus = true;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <SingleImageCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <SingleImageCard {...dataToShare} />
      }
      else if (cat === preference.TYPE_CARD_VALUE_DATA) {
        minW = 1;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <DataValueCardGrid {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <DataValueCardGrid {...dataToShare} />
      } else if (cat === preference.TYPE_TITLE) {
        minW = 2;
        minH = 1;
        maxW = 4;
        maxH = 1;
        h = 1;
        dataToShare.h = 1;
        dataToShare.cardHeight = calcGridHeight(h);
        skeletonWidth = '64%'
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <TitleGrid {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <TitleGrid {...dataToShare} />
      } else if (cat === preference.TYPE_DROPDOWN_SELECTOR) {
        minW = 2;
        minH = 1;
        maxW = 4;
        maxH = 1;
        if (w < 2)
          w = 2;
        dataToShare.w = 2;
        h = 1;
        dataToShare.h = 1;
        skeletonWidth = '64%'
        skeletonPosition = 'right'
        dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <DropdownSelectorGrid {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <DropdownSelectorGrid {...dataToShare} />
      } else if (cat === preference.TYPE_THREE_PHASE) {
        hasFocus = true;
        minW = 1;
        minH = 4;
        maxW = 4;
        maxH = 4;
        if (h < 4) {
          dataToShare.h = 4;
          h = 4;
        }
        dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ThreePhaseCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ThreePhaseCard {...dataToShare} />
      } else if (cat === preference.TYPE_COORDINATE) {
        hasFocus = true;
        minW = 1;
        minH = 4;
        maxW = 4;
        maxH = 4;
        if (h < 4) {
          dataToShare.h = 4;
          h = 4;
        }
        dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <CoordinateCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <CoordinateCard {...dataToShare} />
      }
      else if (cat === preference.TYPE_STRAIN) {
        hasFocus = true;
        minW = 1;
        minH = 4;
        maxW = 4;
        maxH = 4;
        if (h < 4) {
          dataToShare.h = 4;
          h = 4;
        }
        dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <StrainCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <StrainCard {...dataToShare} />
      } else if (cat === preference.TYPE_CRACK) {
        hasFocus = true;
        minW = 1;
        minH = 4;
        maxW = 4;
        maxH = 4;
        if (h < 4) {
          dataToShare.h = 4;
          h = 4;
        }
        dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <CrackCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <CrackCard {...dataToShare} />
      } else if (cat === preference.TYPE_LIST || cat === preference.TYPE_LIST_CUSTOM || cat === preference.TYPE_LIST_TRANSACTION
        || cat === preference.TYPE_LIST_PAYMENT) {
        hasFocus = true;
        minW = 1;
        minH = 4;
        maxW = 4;
        maxH = 10;
        if (h < 4)
          h = 4;
        if (w < 2)
          w = 2;
        dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ListCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ListCard {...dataToShare} />
      } else if (cat === preference.TYPE_GRAPH_LINE_SMART || cat === preference.TYPE_GRAPH_LINE || cat === preference.TYPE_GRAPH_TEXT ||
        cat === preference.TYPE_GRAPH_LINE_MONITORING || cat === preference.TYPE_GRAPH_BAR || cat === preference.TYPE_GRAPH_BAR_MONITORING ||
        cat === preference.TYPE_GRAPH_AREA || cat === preference.TYPE_GRAPH_AREA_MONITORING || cat === preference.TYPE_GRAPH_PIE ||
        cat === preference.TYPE_GRAPH_PIE_MONITORING) {
        hasFocus = true;
        minW = 1;
        minH = 6;
        maxW = 4;
        maxH = 10;
        if (w < 2)
          w = 2;
        if (h < 4)
          h = 4;
        dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <GraphCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <GraphCard {...dataToShare} />
      } else if (cat === preference.TYPE_BUTTON_SIMPLE) {
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <SimpleButtonCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <SimpleButtonCard {...dataToShare} />
      } else if (cat === preference.TYPE_DOWNLOAD_DATA) {
        hasFocus = true;
        minW = 1;
        minH = 1;
        maxW = 1;
        maxH = 2;
        w = 1;
        h = 2;
        dataToShare.w = 1;
        dataToShare.h = 2;
        dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <SimpleDownloadCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <SimpleDownloadCard {...dataToShare} />
      } else if (cat === preference.TYPE_MAP) {
        minW = 1;
        minH = 2;
        maxW = 4;
        maxH = 10;
        if (w < 1)
          w = 1;
        if (h < 2)
          h = 2; dataToShare.cardHeight = calcGridHeight(h);
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <GoogleMapCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <GoogleMapCard {...dataToShare} />
      } else if (cat === preference.BUTTON_TAGS_CARD) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ControlButtonCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ControlButtonCard {...dataToShare} />
      } else if (cat === preference.INPUT_NUMBER_TAGS_CARD) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ControlButtonCardNumber {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ControlButtonCardNumber {...dataToShare} />
      } else if (cat === preference.INPUT_TOGGLE_TAGS_CARD) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ControlButtonCardBoolean {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ControlButtonCardBoolean {...dataToShare} />
      } else if (cat === preference.TYPE_UPLOAD_CSV) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <UploadCSVCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <UploadCSVCard {...dataToShare} />
      } else if (cat === preference.INPUT_TEXT_TAGS_CARD) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ControlButtonCardString {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ControlButtonCardString {...dataToShare} />
      } else if (cat === preference.BUTTON_CUSTOM_CARD) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <CustomControlButtonCard {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <CustomControlButtonCard {...dataToShare} />
      } else if (cat === preference.INPUT_NUMBER_CUSTOM_CARD) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <CustomControlButtonCardNumber {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <CustomControlButtonCardNumber {...dataToShare} />
      } else if (cat === preference.INPUT_TOGGLE_CUSTOM_CARD) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <CustomControlButtonCardBoolean {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <CustomControlButtonCardBoolean {...dataToShare} />
      } else if (cat === preference.TYPE_BUTTON_INPUT_NUMBER) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ButtonInputCardNumber {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ButtonInputCardNumber {...dataToShare} />
      } else if (cat === preference.TYPE_BUTTON_INPUT_TEXT) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ButtonInputCardText {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ButtonInputCardText {...dataToShare} />
      } else if (cat === preference.TYPE_BUTTON_INPUT_TOGGLE) {
        hasFocus = true;
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ButtonInputCardToggle {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ButtonInputCardToggle {...dataToShare} />
      } else if (cat === preference.TYPE_BUTTON_INPUT_DATE) {
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        if (w < 2)
          w = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ButtonInputCardDate {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ButtonInputCardDate {...dataToShare} />
      } else if (cat === preference.TYPE_BUTTON_INPUT_DATE_RANGE) {
        minW = 2;
        minH = 2;
        maxW = 4;
        maxH = 2;
        if (w < 2)
          w = 2;
        dataCardObject = setObjectData(key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus,
          <ButtonInputCardDateRange {...dataToShare} />, dataToShare)
        dataCard.push(dataCardObject)
        cardView =
          <ButtonInputCardDateRange {...dataToShare} />
      }

      let withLoadConfig =
        <Suspense fallback={<SuspenseLoading height={dataToShare.cardHeight} width={skeletonWidth} position={skeletonPosition} />}>
          {cardView}
        </Suspense>
      let _containerClassname = '';
      let _focusCard = '';
      let _focusContainer = '';
      let _cardClassname = '';
      let _middleClassname = '';

      // Fit Width
      let cardWidth = contentWidth - 20;
      if (w === 1) {
        if (contentWidth > 768)
          cardWidth = (((cardWidth - 10) / 2) - 9) / 2;
        else if (contentWidth > 480)
          cardWidth = (cardWidth - 10) / 2;
      } else if (w === 2) {
        if (contentWidth > 996)
          cardWidth = (cardWidth - 10) / 2;
      }

      let cursor = 'default';
      let isShown = false

      if (isDraggable) {
        isShown = true
        if (onDrag) {
          cursor = 'grabbing';
        } else {
          cursor = 'grab';
        }
        _containerClassname = 'containers';
        _cardClassname = 'cardssss';
        _middleClassname = 'middle';
      }

      if (hasFocus) {
        _focusContainer = 'io-card io-card__shadow-sm io-card__hover'
      }

      if (cardView !== null) {
        mainViewDashConfig.push(
          <div key={key} className={`${_containerClassname} ${_focusContainer}`}
            data-grid={{ x, y, w, h, minH, minW, maxW, maxH, isResizable: false, isDraggable }}  > {/* magic is here for react-grid */}
            <div className={`${_cardClassname}`} style={{ minHeight: '100%' }}>
              {withLoadConfig}
            </div>
            {isShown &&
              <div className={_middleClassname} style={{
                cursor, minWidth: '100%', minHeight: '100%',
                alignItems: 'center', justifyContent: 'center', textAlign: 'center', display: 'flex', flex: 1
              }}>
                <div className='row'>
                  <div className='col-md-6' >
                    <Button variant="outlined" color="primary" onClick={() => _this.handleEdit(id)}>
                      Edit
                    </Button>
                  </div>
                  <div className='col-md-6' style={{ color: '#ff6661' }} >
                    <Button variant="outlined" color="inherit" onClick={() => _this.handleDelete(id)}>
                      Delete
                    </Button>
                  </div>
                </div>
              </div>
            }
          </div>
        )
      }
      // end of if cardView!== null
    }
    // end of for

    if (!isEmpty(dataCard)) {
      dataCard = setOrderDataCard(dataCard)
      for (var i in dataCard) {
        let dataI = dataCard[i]
        let dataIH = dataI.h
        let dataIW = dataI.w
        let dataIX = dataI.x
        let skeletonWidth = dataI.skeletonWidth
        let skeletonPosition = dataI.skeletonPosition
        let _containerClassname = 'containers'
        let _focusContainer = ''
        let _cardClassname = ''
        // select for content wrapping card or not
        if (dataI.hasFocus) _focusContainer = 'io-card io-card__shadow-sm io-card__hover'
        // classnames below use for new responsive dashboard using css class 
        let _heightClassname = '';
        let _widthClassname = '';
        let _horizontalPositionClassname = '';
        //  logic if for h, w, and x below use for new responsive dashboard using css class
        // get h value for size height card on grid
        if (dataIH > 0) {
          if (dataIH === 1) _heightClassname = 'iot-row-1'
          else if (dataIH === 2) _heightClassname = 'iot-row-2'
          else if (dataIH === 4) _heightClassname = 'iot-row-4'
          else if (dataIH === 6) _heightClassname = 'iot-row-6'
          else if (dataIH === 8) _heightClassname = 'iot-row-8'
          else if (dataIH === 10) _heightClassname = 'iot-row-10'
        }
        // get w value for size width card on grid
        if (dataIW > 0) {
          if (dataIW === 1) _widthClassname = 'iot-column-1'
          else if (dataIW === 2) _widthClassname = 'iot-column-2'
          else if (dataIW === 3) _widthClassname = 'iot-column-3'
          else if (dataIW === 4) _widthClassname = 'iot-column-4'
        }
        // get x value for horizontal position card
        if (dataIX > -1) {
          if (dataIX === 0) {
            _horizontalPositionClassname = 'iot-column-position-1'
          }
          else if (dataIX === 1) {
            if (dataIW === 4) _horizontalPositionClassname = 'iot-column-position-1'
            else if (dataIW < 4) _horizontalPositionClassname = 'iot-column-position-2'
          }
          else if (dataIX === 2) {
            if (dataIW === 4) _horizontalPositionClassname = 'iot-column-position-1'
            else if (dataIW === 3) _horizontalPositionClassname = 'iot-column-position-2'
            else if (dataIW < 3) _horizontalPositionClassname = 'iot-column-position-3'
          }
          else if (dataIX === 3) {
            if (dataIW === 4) _horizontalPositionClassname = 'iot-column-position-1'
            else if (dataIW === 3) _horizontalPositionClassname = 'iot-column-position-2'
            else if (dataIW === 2) _horizontalPositionClassname = 'iot-column-position-3'
            else if (dataIW < 2) _horizontalPositionClassname = 'iot-column-position-4'
          }
        }

        let withLoadPreview =
          <Suspense fallback={<SuspenseLoading height={dataI.dataToShare.cardHeight}
            width={skeletonWidth}
            position={skeletonPosition} />}>
            {dataI.component}
          </Suspense>
        mainViewDashPreview.push(
          <div key={dataI.key} className={`${_containerClassname} ${_focusContainer}
          ${_heightClassname} ${_widthClassname} ${_horizontalPositionClassname}`}>
            <div className={`${_cardClassname}`} style={{ minHeight: '100%' }}>
              {withLoadPreview}
            </div>
          </div>
        )
      }
    }

    let element = []
    if (staticGrid) element = <div className="iot-container-grid"> {mainViewDashPreview}</div>
    else element =
      <ResponsiveGridLayout
        className="layout"
        onResize={this.onResize}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 4, md: 4, sm: 2, xs: 2, xxs: 1 }}
        rowHeight={ROW_HEIGHT}
        width={contentWidth}
        layouts={layouts}
        margin={[MARGIN, MARGIN]}
        onLayoutChange={(layout, layouts) =>
          this.onLayoutChange(layout, layouts)
        }
        onDragStart={() => this.setState({ onDrag: true })}
        onDragStop={() => this.setState({ onDrag: false })}
      >
        {mainViewDashConfig}
      </ResponsiveGridLayout >
    let wrappingView = [];
    wrappingView = <div style={{ margin: 0 }}>{element}</div>
    return wrappingView;
  }
}

function createGraphData(graphOutput, _var, cat, graphOutputLabel = null) {
  let isPie = false;
  if (cat === preference.TYPE_GRAPH_PIE_MONITORING || cat === preference.TYPE_GRAPH_PIE) {
    isPie = true
  }
  if (graphOutput.length < 1) {
    return;
  }
  let chart_keys = []
  let chart_data = []
  graphOutput.forEach((currVarKey, index) => {
    currVarKey = removeBracet(currVarKey)
    if (currVarKey in _var) {
      let selectedVar = _var[currVarKey];
      if ('subparam_label' in selectedVar) {
        let subparam_label = selectedVar.subparam_label;
        if (isPie) {
          chart_data.push({
            value: Math.floor(Math.random() * 100),
            name: subparam_label
          })
          chart_keys.push(
            subparam_label
          )
        } else {
          subparam_label.forEach(item => {
            chart_keys.push(
              item
            )
          })
        }
      } else if ('subparam' in selectedVar) {
        let subparam = selectedVar.subparam;
        if (isPie) {
          let _subparam = subparam;
          if (graphOutputLabel !== null) {
            _subparam = graphOutputLabel[index]
          }
          chart_data.push({
            value: Math.floor(Math.random() * 100),
            name: _subparam
          })
          chart_keys.push(
            _subparam
          )
        } else {
          subparam.forEach((currItem, index) => {
            chart_keys.push(
              currVarKey + '_' + (index + 1)
            )
          })
        }
      } else if ('param_label' in selectedVar) {
        let param_label = selectedVar.param_label;
        chart_keys.push(
          param_label
        )
        if (isPie)
          chart_data.push({
            value: Math.floor(Math.random() * 100),
            name: param_label
          })
      } else if ('param' in selectedVar) {
        let param = selectedVar.param;
        if (isPie) {
          let _param = param;
          if (graphOutputLabel !== null) {
            _param = graphOutputLabel[index]
            param = _param
          }
          chart_data.push({
            value: Math.floor(Math.random() * 100),
            name: _param
          })
        }
        chart_keys.push(
          param
        )
      }
    } else {
      chart_keys.push(
        currVarKey
      )
      if (isPie)
        chart_data.push({
          value: Math.floor(Math.random() * 100),
          name: currVarKey
        })
    }
  })
  if (!isPie) {
    for (let i = 11; i > 1; i--) {
      let data = {}
      let now = moment().unix() * 1000;
      let x = now - (i * 1000)
      let nowString = toDate(x, 'YYYY-MM-DD HH:mm:ss')
      data.x = nowString;
      chart_keys.forEach(item => {
        data[item] = Math.floor(Math.random() * 100);
      })
      chart_data.push(data)
    }
  }
  return { chart_data, chart_keys }
}

function buildFilter(filters, _var) {
  let finalFilter = {};
  filters = removeBracet(filters)
  let length = 0;
  for (let keys in _var[filters]) {
    let filter = _var[filters][keys]; // object
    if ((!isObject(filter) && !isEmpty(filter)) && filter !== undefined && filter !== null) {
      continue;
    }
    let name = safeDeepGet(filter, ['name'], null)
    let range = safeDeepGet(filter, ['range'], null)
    let range_param = safeDeepGet(filter, ['range_param'], null)
    let period = safeDeepGet(filter, ['period'], null)
    let interval = safeDeepGet(filter, ['interval'], null)
    let ndata = safeDeepGet(filter, ['ndata'], null)
    if (length === 0) {
      finalFilter.default = {
        name,
        range,
        range_param,
        period,
        interval,
        ndata
      }
    } else {
      finalFilter[keys] = {
        name,
        range,
        range_param,
        period,
        interval,
        ndata
      }
    }
    length++;
  }
  if (length === 0) {
    finalFilter.custom = {
      name: 'custom',
      id: 'custom',
      type: preference.FILTER_CUSTOM
    }
  }
  return finalFilter
}

// class for preview when add component
export class PreviewGenerator extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      layouts: JSON.parse(JSON.stringify(originalLayouts))
    };
  }
  render() {
    let contentWidth = safeDeepGetWithType(this, ['props', 'contentWidth'], 360);
    let staticGrid = safeDeepGetWithType(this, ['props', 'staticGrid'], true);
    let isDraggable = staticGrid ? false : true;
    let cardView = null;
    let y = 0
    let x = safeDeepGetWithType(this, ['props', 'x'], 1);
    let w = safeDeepGetWithType(this, ['props', 'w'], 2);
    let h = safeDeepGetWithType(this, ['props', 'h'], 1);
    h *= 2
    let cat = safeDeepGetWithType(this, ['props', 'cat'], "CARD");
    let type = safeDeepGetWithType(this, ['props', 'type'], "CUSTOM");
    let title = safeDeepGetWithType(this, ['props', 'title'], '');
    if (title === '') {
      title = 'title'
    }
    title = titleCase(title);

    // Single Value Data
    let value = safeDeepGet(this, ['props', 'value'], '');

    let valueDef = safeDeepGet(this, ['props', 'value'], '');
    if (value === '') {
      value = 'Value'
    }
    value = inputToString(value);

    let value_1 = safeDeepGet(this, ['props', 'value_1'], '');
    if (value_1 === '') {
      value_1 = 'Value 1'
    }
    value_1 = inputToString(value_1);

    let value_2 = safeDeepGet(this, ['props', 'value_2'], '');
    if (value_2 === '') {
      value_2 = 'Value 2'
    }
    value_2 = inputToString(value_2);

    let value_3 = safeDeepGet(this, ['props', 'value_3'], '');
    if (value_3 === '') {
      value_3 = 'Value 3'
    }
    value_3 = inputToString(value_3);

    let status_1 = safeDeepGet(this, ['props', 'status_1'], '');
    status_1 = inputToString(status_1);

    let status_2 = safeDeepGet(this, ['props', 'status_2'], '');
    status_2 = inputToString(status_2);

    let status_3 = safeDeepGet(this, ['props', 'status_3'], '');
    status_3 = inputToString(status_3);

    let unit = safeDeepGetWithType(this, ['props', 'unit'], '');
    let unit_front = safeDeepGetWithType(this, ['props', 'unit_front'], false);

    let table = safeDeepGetWithType(this, ['props', 'table'], []);
    let table_keys = safeDeepGetWithType(this, ['props', 'table_keys'], []);

    let _var = safeDeepGetWithType(this, ['props', '_var'], {});
    let _varGlobal = safeDeepGetWithType(this, ['props', '_varGlobal'], {});

    let _varMix = { ..._varGlobal, ..._var }

    let is_stack = safeDeepGetWithType(this, ['props', 'is_stack'], false);
    let with_summary = safeDeepGetWithType(this, ['props', 'with_summary'], is_stack);
    let graph_unit = safeDeepGetWithType(this, ['props', 'graph_unit'], '');
    let graph_output = safeDeepGetWithType(this, ['props', 'graph_output'], []);
    let graph_output_label = safeDeepGetWithType(this, ['props', 'graph_output_label'], []);

    let test = {}
    const haveOutputLabel = graph_output.length === graph_output_label.length
    if (preference.isChart(cat)) {
      if (haveOutputLabel) {
        test = createGraphData(graph_output, _var, cat, graph_output_label);
      } else {
        test = createGraphData(graph_output, _var, cat);
      }
    }

    let data = safeDeepGetWithType(test, ['chart_data'], [])
    let chart_keys = safeDeepGetWithType(test, ['chart_keys'], [])

    if (haveOutputLabel) {
      chart_keys = graph_output_label
    }

    let filters = safeDeepGetWithType(this, ['props', 'filters'], '')

    let chart_period = buildFilter(filters, _varMix);
    let devices = [
      { 'device_id': 'aaaaaa', 'label': 'Perangkat 1' },
      { 'device_id': 'bbbbbb', 'label': 'Perangkat 2' },
      { 'device_id': 'cccccc', 'label': 'Perangkat 3' }
    ]
    let dataToShare = {
      title,
      unit,
      unit_front,
      contentWidth,
      date_short: 'Time',
      cat,
      x,
      y,
      w,
      h,

      value,
      value_1,
      value_2,
      value_3,
      status_1,
      status_2,
      status_3,

      table,
      table_keys,
      devices,
      data,
      chart_keys,
      chart_period,
      graph_unit,
      is_second_shown: true,
      is_stack,
      with_summary

    }

    clean(dataToShare);

    if (cat === preference.TYPE_CARD_VALUE) {
      dataToShare.w = 1;
      switch (type) {
        case preference.TYPE_CUSTOM:
          cardView =
            <CustomCardGrid {...dataToShare} />
          break;
        case preference.TYPE_AMPERE:
          cardView =
            <AmpereCardGrid {...dataToShare} />
          break;
        case preference.TYPE_KW:
          cardView =
            <KWCardGrid {...dataToShare} />
          break;
        case preference.TYPE_KWH:
          cardView =
            <KWHCardGrid {...dataToShare} />
          break;
        case preference.TYPE_OHM:
          cardView =
            <OhmCardGrid {...dataToShare} />
          break;
        case preference.TYPE_VOLT:
          cardView =
            <VoltCardGrid {...dataToShare} />
          break;
        case preference.TYPE_WATT:
          cardView =
            <WattCardGrid {...dataToShare} />
          break;
        case preference.TYPE_HUMIDITY:
          cardView =
            <HumidityCardGrid {...dataToShare} />
          break;
        case preference.TYPE_PERCENT:
          cardView =
            <PercentageCardGrid {...dataToShare} />
          break;
        case preference.TYPE_PRESSURE_AIR:
          cardView =
            <PreasureAirCardGrid {...dataToShare} />
          break;
        case preference.TYPE_PRESSURE_WATER:
          cardView =
            <PreasureWaterCardGrid {...dataToShare} />
          break;
        case preference.TYPE_RUPIAH:
          cardView =
            <SalesCardGrid {...dataToShare} />
          break;
        case preference.TYPE_TEMPERATURE_CELCIUS:
          cardView =
            <CelciusCardGrid {...dataToShare} />
          break;
        case preference.TYPE_TEMPERATURE_FAHRENHEIT:
          cardView =
            <FahrenheitCardGrid {...dataToShare} />
          break;
        case preference.TYPE_TEMPERATURE_KELVIN:
          cardView =
            <KelvinCardGrid {...dataToShare} />
          break;
        case preference.TYPE_VERSION:
          cardView =
            <VersionCardGrid {...dataToShare} />
          break;
        default:
          break;
      }
    } else if (cat === preference.TYPE_CARD_VALUE_DATA) {
      cardView =
        <DataValueCardGrid {...dataToShare} />
    } else if (cat === preference.TYPE_TITLE) {
      h = 1;
      dataToShare.h = 1;
      dataToShare.cardHeight = calcGridHeight(h);
      if (valueDef === '') {
        dataToShare.value = 'Title';
      }
      cardView =
        <TitleGrid {...dataToShare} />
    } else if (cat === preference.TYPE_THREE_PHASE) {
      if (h < 4) {
        dataToShare.h = 4;
        h = 4;
      }
      dataToShare.value_1 = safeDeepGetWithType(_var, [value, 'subparam', 0], 'Value 1');
      dataToShare.value_2 = safeDeepGetWithType(_var, [value, 'subparam', 1], 'Value 2');
      dataToShare.value_3 = safeDeepGetWithType(_var, [value, 'subparam', 2], 'Value 3');
      dataToShare.cardHeight = calcGridHeight(h);
      cardView =
        <ThreePhaseCard {...dataToShare} />
    } else if (cat === preference.TYPE_LIST || cat === preference.TYPE_LIST_CUSTOM || cat === preference.TYPE_LIST_TRANSACTION ||
      preference.TYPE_LIST_PAYMENT
    ) {
      if (h < 4)
        h = 4;
      if (w < 2)
        w = 2;
      dataToShare.cardHeight = calcGridHeight(h);
      cardView =
        <ListCard {...dataToShare} />
    } else if (cat === preference.TYPE_GRAPH_LINE_SMART || cat === preference.TYPE_GRAPH_LINE || cat === preference.TYPE_GRAPH_TEXT ||
      cat === preference.TYPE_GRAPH_LINE_MONITORING || cat === preference.TYPE_GRAPH_BAR || cat === preference.TYPE_GRAPH_BAR_MONITORING ||
      cat === preference.TYPE_GRAPH_AREA || cat === preference.TYPE_GRAPH_AREA_MONITORING || cat === preference.TYPE_GRAPH_PIE ||
      cat === preference.TYPE_GRAPH_PIE_MONITORING) {
      if (w < 2)
        w = 2;
      if (h < 4)
        h = 4;
      dataToShare.cardHeight = calcGridHeight(h);
      cardView =
        <GraphCard {...dataToShare} />
    } else if (cat === preference.TYPE_BUTTON_SIMPLE) {
      cardView =
        <SimpleButtonCard {...dataToShare} />
    } else if (cat === preference.TYPE_MAP) {
      if (w < 1)
        w = 1;
      if (h < 2)
        h = 2;
      dataToShare.cardHeight = calcGridHeight(h);
      cardView =
        <GoogleMapCard {...dataToShare} />
    }
    else if (cat === preference.TYPE_DOWNLOAD_DATA) {
      w = 1;
      h = 2;
      dataToShare.w = 1;
      dataToShare.h = 2;
      dataToShare.cardHeight = calcGridHeight(h);
      cardView =
        <SimpleDownloadCard {...dataToShare} />
    } else if (cat === preference.BUTTON_TAGS_CARD) {
      cardView =
        <ControlButtonCard {...dataToShare} />
    } else if (cat === preference.INPUT_NUMBER_TAGS_CARD) {
      cardView =
        <ControlButtonCardNumber {...dataToShare} />
    } else if (cat === preference.INPUT_TOGGLE_TAGS_CARD) {
      cardView =
        <ControlButtonCardBoolean {...dataToShare} />
    } else if (cat === preference.BUTTON_CUSTOM_CARD) {
      cardView =
        <CustomControlButtonCard {...dataToShare} />
    } else if (cat === preference.INPUT_NUMBER_CUSTOM_CARD) {
      cardView =
        <CustomControlButtonCardNumber {...dataToShare} />
    } else if (cat === preference.INPUT_TOGGLE_CUSTOM_CARD) {
      cardView =
        <CustomControlButtonCardBoolean {...dataToShare} />
    } else if (cat === preference.TYPE_BUTTON_INPUT_NUMBER) {
      cardView =
        <ButtonInputCardNumber {...dataToShare} />
    } else if (cat === preference.TYPE_BUTTON_INPUT_TEXT) {
      cardView =
        <ButtonInputCardText {...dataToShare} />
    } else if (cat === preference.TYPE_BUTTON_INPUT_TOGGLE) {
      cardView =
        <ButtonInputCardToggle {...dataToShare} />
    } else if (cat === preference.TYPE_BUTTON_INPUT_DATE) {
      if (w < 2)
        w = 2;
      cardView =
        <ButtonInputCardDate {...dataToShare} />
    } else if (cat === preference.TYPE_BUTTON_INPUT_DATE_RANGE) {
      if (w < 2)
        w = 2;
      cardView =
        <ButtonInputCardDateRange {...dataToShare} />
    }

    let mainView = []

    let withLoad =
      <Suspense fallback={<div />}>
        {cardView}
      </Suspense>

    if (cardView !== null) {
      mainView.push(
        <div className='io-card io-card__shadow-sm' key={'key'}
          data-grid={{ x, y, w, h, isResizable: false, isDraggable }} > {/* magic is here for react-grid */}
          <div className="cardError" style={{ minHeight: '100%' }}>
            {withLoad}
          </div>
        </div>
      )
    }
    let element = [];
    element =
      <ResponsiveGridLayout
        className="layout"
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 4, md: 4, sm: 4, xs: 4, xxs: 4 }}
        rowHeight={ROW_HEIGHT}
        margin={[MARGIN, MARGIN]}
        width={contentWidth}
        layouts={this.state.layouts}
      >
        {mainView}
      </ResponsiveGridLayout >

    let wrappingView = [];
    wrappingView = <div style={{ margin: 0 }}>{element}</div>
    return wrappingView;
  }
}

function getFromLS(key) {
  let ls = {};
  ls = parse(localStorage.getItem(key));
  if (ls === null) {
    ls = {}
  }
  if (key in ls) {
    return ls[key];
  } else {
    return ls
  }
}

function saveToLS(key, value) {
  if (global.localStorage) {
    global.localStorage.setItem(
      "rgl-8",
      JSON.stringify({
        [key]: value
      })
    );
  }
}